<template>
	<div class="acount-info-main-div">
		<span style="color: #C0C4CC; font-size: small; ">{{$t('vip.credit.balance')}}</span>
		<br />
		<div class="info-div">
			<span>
				<span style="font-weight: bolder; font-size:3rem; ">
					{{ loginUser.account.balance }}
				</span>
				{{$t('vip.credit.name')}}
			</span>
			<el-button @click="$router.push('/recharge')"  class="rechage-btn" type="primary">{{$t('vip.credit.recharge')}}</el-button>
		</div>
	</div>
</template>

<script>
import TRADING_RECORD_SUB from '@/components/template/view/userInfo/tradingAccount/tradingRecord'

export default {
	name: 'tradingAccountInfoPage',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg','LOGINUSER'],
	data() {return {
		loginUser : this.LOGINUSER,
	}},
	created() {
		
	},
	components:{
		'trading-record-sub' : TRADING_RECORD_SUB
	},
	methods:{

	},
	watch: {},	
}
</script>

<style scoped>
.acount-info-main-div{
	padding: 30px 20px;
}
.info-div{
	padding: 10px 0px;
	border-bottom: 1px solid #DCDFE6;
}
.rechage-btn{
	width: 140px;
	height: 45px;
	float: right;
	margin-right: 10px;
	margin-top: 5px;
	font-size: 18px;
}
</style>